import Layout from "./components/Layout";
import Loader from "../Tools/Loader";
import DpcDouble from "./components/DpcDouble";
import Finish from "./components/Finish";
import useDpcItems from "./utils/useDpcItems";

export default function DpcSuccess(){

    const query = useDpcItems()

    return (
        <Layout>

            {query.isLoading &&
                <Loader />
            }

            {query.isSuccess && 
                <DpcDouble />
            }

            {query.isError  && 
                <Finish />
            }

        </Layout>
    );
}